<template>
    <div class="login-box" :class="$style.wrapper">
        <div class="login-logo">{{ config.app_name }}</div>

        <div class="card">
            <div class="card-body login-card-body">
                <div v-if="authenticating" :class="$style.authenticating">
                    <i class="fa-solid fa-spinner fa-spin" />
                    <span>Verifying account...</span>
                </div>

                <template v-else>
                    <h4>Magic Link Sign In</h4>

                    <input
                        ref="email"
                        v-model="email"
                        type="text"
                        class="form-control"
                        placeholder="Enter email address..."
                        @keypress.enter="submit"
                    />

                    <button
                        name="submit"
                        class="btn btn-primary"
                        type="submit"
                        @click="submit"
                    >
                        <i class="fa-solid fa-sign-in-alt"></i>
                        Submit
                    </button>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { Message } from 'larasnap/support';
import { $http } from 'larasnap';
import Magic from './util/magic';

export default {
    props: {
        config: Object,
    },
    data() {
        return {
            authenticating: false,
            email: '',
        };
    },
    mounted() {
        this.$nextTick(() => {
            $(this.$refs.email).focus();
        });
    },
    created() {
        Magic.init(this.config.public_api_key);
    },
    methods: {
        async submit() {
            const magic = await Magic.getInstance();
            await magic.auth.loginWithMagicLink({ email: this.email });
            await this.authenticate(magic.user);
        },
        async authenticate(user) {
            this.authenticating = true;
            const token = await user.getIdToken();

            return $http
                .post('/magic/validate-token', { token })
                .then(({ data: { foundUser, redirectUrl, message } }) => {
                    if (foundUser) {
                        user.logout();
                        window.location.href = redirectUrl;
                    } else {
                        this.authenticating = false;
                        Message.error(message);
                    }
                })
                .catch(() => {
                    this.authenticating = false;
                });
        },
    },
};
</script>

<style lang="scss" module>
.wrapper {
    input {
        margin-top: 6px;
        margin-bottom: 14px;
    }
}
.authenticating {
    font-size: 1.2em;
    font-style: italic;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
        font-size: 1.6em;
    }
    span {
        margin-left: 6px;
    }
}
</style>
